import * as React from 'react';

import { CommonIconProps, IconSize } from 'shared/entities/components/Icon';

import BaseIcon from '../BaseIcon';

const PhoneIcon: React.FC<CommonIconProps> = (props: CommonIconProps) => {
  return (
    <BaseIcon
      iconSize={IconSize.S}
      svgProps={{
        viewBox: '0 0 15 15'
      }}
      {...props}
    >
      <path
        d="M5.09314 5.62221C5.52814 6.52822 6.12113 7.37738 6.87212 8.12836C7.62311 8.87935 8.47226 9.47234 9.37827 9.90734C9.4562 9.94476 9.49517 9.96347 9.54447 9.97784C9.71969 10.0289 9.93486 9.99223 10.0832 9.88597C10.125 9.85607 10.1607 9.82035 10.2322 9.7489C10.4507 9.5304 10.5599 9.42115 10.6698 9.34972C11.0841 9.08035 11.6182 9.08035 12.0325 9.34972C12.1424 9.42115 12.2516 9.5304 12.4701 9.7489L12.5919 9.8707C12.9241 10.2028 13.0902 10.3689 13.1804 10.5473C13.3598 10.902 13.3598 11.3209 13.1804 11.6757C13.0902 11.854 12.9241 12.0201 12.5919 12.3522L12.4934 12.4508C12.1624 12.7818 11.9969 12.9473 11.7719 13.0737C11.5222 13.214 11.1344 13.3148 10.848 13.314C10.5899 13.3132 10.4135 13.2631 10.0607 13.163C8.16484 12.6249 6.37587 11.6096 4.88338 10.1171C3.39089 8.62461 2.3756 6.83564 1.83749 4.93976C1.73736 4.58699 1.6873 4.4106 1.68653 4.1525C1.68568 3.86612 1.78653 3.47831 1.92679 3.22862C2.0532 3.0036 2.2187 2.83809 2.54972 2.50708L2.64824 2.40855C2.98039 2.0764 3.14647 1.91033 3.32483 1.82011C3.67956 1.64069 4.09847 1.64069 4.4532 1.82011C4.63156 1.91033 4.79763 2.0764 5.12979 2.40855L5.25158 2.53035C5.47008 2.74885 5.57934 2.8581 5.65076 2.96796C5.92014 3.38227 5.92014 3.91638 5.65076 4.33069C5.57934 4.44055 5.47008 4.5498 5.25158 4.76831C5.18013 4.83975 5.14441 4.87547 5.11451 4.91723C5.00825 5.06563 4.97157 5.28079 5.02264 5.45601C5.03702 5.50532 5.05573 5.54428 5.09314 5.62221Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

export default PhoneIcon;
